import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export default function useDTBsReportExport() {
  const generate = async (
    orgId: string,
    params: Record<string, any> = {},
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/reports/v1/organizations/${orgId}/reports/dtbs/full-audit`;
    const paramString = new URLSearchParams(
      Object.entries({
        ...params,
        fileType: 'XLS',
      })
        .filter(([_k, v]) => v != null)
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    ).toString();
    await fetcher({
      url: `${url}?${paramString}`,
      method: 'post',
      body: {},
    })
      .then((data) => {
        if (callback) callback();
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    generate,
  };
}
